import createVueComponent from '../createVueComponent';

const TextCursor = createVueComponent('TextCursorIcon', [
  ['path', { d: 'M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1', key: 'uvaxm9' }],
  ['path', { d: 'M7 22h1a4 4 0 0 0 4-4v-1', key: '11xy8d' }],
  ['path', { d: 'M7 2h1a4 4 0 0 1 4 4v1', key: '1uw06m' }],
]);

export default TextCursor;
